import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("cm_token");
      localStorage.removeItem("cm_user");
    }
    return Promise.reject(err);
  }
);

export const setAuth = (token, user) => {
  localStorage.setItem("cm_token", token);
  localStorage.setItem("cm_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("cm_token");
  localStorage.removeItem("cm_user");
};

export const currentUser = () => {
  const raw = localStorage.getItem("cm_user");
  return raw ? JSON.parse(raw) : null;
};

export const currentToken = () => localStorage.getItem("cm_token");
